import { useAccessContext } from '@rsos/hooks/useHasAccess';
import type { SideBarMenuItem } from './types';
import { shouldSideBarItemRender } from './utils';

/**
 * Filters the sidebar items to those the current user should see, using the same
 * access descriptors, context and predicate that guard the routes themselves.
 *
 * Permissions come from `currentRole.permissions` rather than `pageAccessList`
 * so nav and routes read one source. Both are derived from the same role in the
 * same /user response — pageAccessList is that list filtered to the
 * `rsp_rbac: true` set — so for the page-access permissions the sidebar gates on,
 * this is equivalent.
 */
export default function useRenderSideBarItems(
  sideBarItems: SideBarMenuItem[] = [],
): SideBarMenuItem[] {
  const context = useAccessContext();

  return sideBarItems.filter(item => shouldSideBarItemRender(item, context));
}
